/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Still_Wise_Mole_GnawInputs */

const en_still_wise_mole_gnaw = /** @type {(inputs: Still_Wise_Mole_GnawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select file`)
};

const de_still_wise_mole_gnaw = /** @type {(inputs: Still_Wise_Mole_GnawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei auswählen`)
};

/**
* | output |
* | --- |
* | "Select file" |
*
* @param {Still_Wise_Mole_GnawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const still_wise_mole_gnaw = /** @type {((inputs?: Still_Wise_Mole_GnawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Still_Wise_Mole_GnawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_still_wise_mole_gnaw(inputs)
	return de_still_wise_mole_gnaw(inputs)
});